<template>
  <div class="order-header">
    <span class="title">近期任务</span>
    <el-checkbox-group v-model="taskMathineList" v-if="mathineList?.length > 0">
      <div class="dogrole">
        <div class="item" :class="{ running: item?.status == 2, error: item?.status == 3, disabled: item?.status == 1 }" v-for="(item, index) in mathineList" :key="index">
          <el-checkbox :key="item?.id" :value="item?.id" /><em />
          <el-tooltip effect="light" :content="CONST.MATHINE_STATUS_LABEL[item?.status]" placement="top">
            <span>{{item?.name}}</span>
          </el-tooltip>
        </div>
      </div>
    </el-checkbox-group>
  </div>
  <div class="order-list">
    <div class="item-block" :class="{ 'today-before': item.today == -1, 'today': item.today == 0, 'today-after': item.today == 1 }" v-for="(item, index) in taskList" :key="index">
      <div class="line" />
      <div class="item-block-header"><em /><span>{{item?.title}}/{{ item?.children?.length }}个</span></div>
      <div class="item-stat-wrap" v-if="item.children?.length > 0 && item.today == 0">
        <div class="item-stat running"><label>今日待执行应用数</label><span>{{ todayTaskDetail?.toBeExecutedAppCount || 0 }}</span></div>
        <div class="item-stat pending"><label>今日待执行子任务数</label><span>{{ todayTaskDetail?.toBeExecutedSubAppCount || 0 }}</span></div>
        <div class="item-stat default"><label>今日已完成应用数</label><span>{{ todayTaskDetail?.executionCompletedAppCount || 0 }}</span></div>
        <div class="item-stat default"><label>今日已完成子任务数</label><span>{{ todayTaskDetail?.executionCompletedSubAppCount || 0 }}</span></div>
        <div class="item-stat error"><label>今日异常子任务数</label><span>{{ todayTaskDetail?.exceptionSubAppCount || 0 }}</span></div>
      </div>
      <div class="items" v-if="item.children?.length > 0">
        <div class="itemcard" v-for="(citem, cindex) in item.children" :key="cindex">
          <div class="card-title">
            <el-tooltip effect="dark" :content="citem?.appName" placement="top">
              <span>{{citem?.appName}}</span>
            </el-tooltip>
            <div class="card-status" :style="{ backgroundColor: CONST.LOGS_STATUS_COLOR[citem.status] }">{{ CONST.LOGS_STATUS_LABEL[citem.status] }}</div>
          </div>
          <div class="card-task-info">
            <div class="tasknumber">
              <span class="value"><i :style="{ 
                color: (() => {
                  let colorKey = citem.status;
                  if(citem.status == CONST.LOGS_STATUS_FINISH) {
                    colorKey = CONST.LOGS_STATUS_RUNNING;
                  }
                  if(citem.status == CONST.LOGS_STATUS_PENDING) {
                    colorKey = CONST.LOGS_STATUS_FINISH;
                  }

                  return CONST.LOGS_STATUS_COLOR[colorKey]
                })()
              }">{{citem?.completedCount}}</i>/{{ citem?.totalCount }}</span>
              <span>已完成/总任务</span>
            </div>
            <div class="tasktime">
              <span class="value">
                <i>{{Utils.convertSeconds(citem?.rt)?.hours}}</i>h
                <i style="padding-left: 1px;">{{Utils.convertSeconds(citem?.rt)?.minutes}}</i>min
              </span>
              <span>工作时长</span>
            </div>
          </div>
          <div class="card-task-msg-wrap">
            <div class="card-task-msg"><label>执行机器人</label><span>{{citem?.machineName}}</span></div>
            <div class="card-task-msg"><label>更新时间</label><span>{{citem?.updateTime && moment(citem?.updateTime).format('YYYY MM.DD HH:mm')}}</span></div>
            <div class="checkdetail" @click="toAppLogs(citem)">查看详情<el-icon><DArrowRight /></el-icon></div>
          </div>
        </div>
      </div>
      <div class="emptyitems" v-else>暂无任务安排</div>
    </div>
    <div class="item-block today-after">
      <div class="item-block-header"><em /><span>更多历史任务，请前往日志中心查看，点击可直接跳转至<i class="checklog" @click="toAppLogs">任务日志</i></span></div>
    </div>
  </div>
</template>

<script setup>
  import {ref, onMounted, watch} from 'vue';
  import { DArrowRight } from '@element-plus/icons-vue';
  import * as Request from '@/assets/request';
  import * as CONST from '@/assets/const';
  import * as Utils from '@/assets/utils';
  import moment from 'moment'
  import { useRouter, useRoute } from 'vue-router';
  const router = useRouter();

  const props = defineProps({
    forceRefresh: {
      type: Boolean,
      defaultValue: false
    }
  })

  // 机器列表
  const mathineList = ref([])
  const taskMathineList = ref([])
  const getMachines = async () => {
    const result = await Request.post({
      url: '/22001/facade/dispatch/machines'
    });
    if(result?.code != 200) return;

    if(result?.data?.length > 0) {
      mathineList.value = result?.data;
      taskMathineList.value = mathineList.value.map(i => i.id)
    }
  }
  onMounted(() => {
    getMachines()
  })

  const taskList = ref([
    { today: -1, title: '明天及以后任务', children: [] },
    { today: 0, title: '今天任务', children: [] },
    { today: 1, title: '昨天任务', children: [] },
  ])
  const todayTaskDetail = ref(null);
  const getTaskList = async () => {
    const result = await Request.post({
      url: '/22001/facade/dispatch/getAppByMachineIds',
      data: taskMathineList.value
    })
    if(result?.code != 200) return;
    
    taskList.value = [
      { today: -1, title: '明天及以后任务', children: result?.data?.tomorrowTasks || [], },
      { today: 0, title: '今天任务', children: result?.data?.todayTasks || [] },
      { today: 1, title: '昨天任务', children: result?.data?.yesterdayTasks || [] },
    ]

    todayTaskDetail.value = result?.data?.todayTaskDetail;
  }
  watch(() => taskMathineList.value, () => {
    getTaskList()
  })
  watch(() => props.forceRefresh, () => {
    if(!props.forceRefresh) return;
    getTaskList();
  })

  // 查看详情
  const toAppLogs = (item) => {
    const queryArr = []
    if(item?.traceId) {
      queryArr.push(`traceId=${item.traceId}`)
    }
    router.push(`/apps-logs${queryArr?.length > 0 ? `?${queryArr.join('&')}` : ''}`);
  }
</script>

<style scoped lang="less">
@import "./index.less";
</style>
